import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/",
    name: "chat",
    component: () => import("../views/chat.vue"),
  },
  {
    path: "/userCenter",
    name: "userCenter",
    component: () => import("../views/userCenter.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/privacy.vue"),
  },
  {
    path: "/service",
    name: "service",
    component: () => import("../views/service.vue"),
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});



// 全局前置守卫：切换路由前，门卫先检查
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("web_login_token");
  let nextRouter = ['/','/login','/about','/privacy','/service']
  if(nextRouter.indexOf(to.path) == -1 && !token){
    next('/login')
  }else{
    next() // 放行
  }
})

  
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
export default router;
